import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "q-gutter-md" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_customer_loader = _resolveComponent("customer-loader")!
  const _component_choose_payment_method = _resolveComponent("choose-payment-method")!
  const _component_show_finally = _resolveComponent("show-finally")!
  const _component_message = _resolveComponent("message")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_customer_loader, {
      "customer-id": _ctx.customerId,
      modelValue: _ctx.customer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customer) = $event))
    }, null, 8, ["customer-id", "modelValue"]),
    (_ctx.customer && _ctx.isTransactional)
      ? (_openBlock(), _createBlock(_component_show_finally, {
          key: 0,
          task: _ctx.task,
          loader: ""
        }, {
          default: _withCtx(() => [
            (!_ctx.isFree)
              ? (_openBlock(), _createBlock(_component_choose_payment_method, {
                  key: 0,
                  "customer-id": _ctx.customerId,
                  "payment-method-id": _ctx.modelValue,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
                }, null, 8, ["customer-id", "payment-method-id"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["task"]))
      : (_ctx.customer && !_ctx.isTransactional)
        ? (_openBlock(), _createBlock(_component_show_finally, {
            key: 1,
            task: _ctx.task,
            loader: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_message, null, {
                default: _withCtx(() => [
                  _createTextVNode(" This charge will be added to your next monthly invoice. ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["task"]))
        : _createCommentVNode("", true),
    (_ctx.price)
      ? (_openBlock(), _createBlock(_component_q_list, {
          key: 2,
          bordered: "",
          class: "radius"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Subtotal")
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, {
                  class: "text-subtitle2",
                  avatar: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.price.subTotal)) + " " + _toDisplayString(_ctx.currency), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            (_ctx.showPromos)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_q_item_label, {
                    header: "",
                    class: "q-pb-none"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Promotions")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.price.promos, (promo) => {
                    return (_openBlock(), _createBlock(_component_q_item, {
                      key: promo.name
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(promo.name) + " ", 1),
                            _createElementVNode("div", null, [
                              _createElementVNode("small", null, _toDisplayString(promo.description), 1)
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_item_section, {
                          class: "text-subtitle2 text-negative",
                          avatar: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" -" + _toDisplayString(_ctx.$filters.currency(promo.amount)) + " " + _toDisplayString(_ctx.currency), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_component_q_separator)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showTaxes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_q_item_label, {
                    header: "",
                    class: "q-pb-none"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Taxes")
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.price.taxes, (tax) => {
                    return (_openBlock(), _createBlock(_component_q_item, {
                      key: tax.abbrev
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tax.abbrev), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_item_section, {
                          class: "text-subtitle2",
                          avatar: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$filters.currency(tax.amount)) + " " + _toDisplayString(_ctx.currency), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_component_q_separator)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Total")
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, {
                  class: "text-subtitle2",
                  avatar: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.price.total)) + " " + _toDisplayString(_ctx.currency), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}